import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index";
import ClassList from "@/components/ClassList";
import SearchSubject from "@/components/SearchSubject";
import QuickReadSubject from "@/components/QuickReadSubject";
import MyClassList from "@/components/MyClassList";
import CourseOutlineList from "@/components/CourseOutlineList";
import CourseOutlineData from "@/components/CourseOutlineData";
import ChapterExercise from "@/components/ChapterExercise";
import SubjuectData from "@/components/SubjuectData";
import ClassBuy from "@/components/ClassBuy";
import SimulationTest from "@/components/SimulationTest";
import BuildPaper from "@/components/BuildPaper";
import ErrorInfo from "@/components/ErrorInfo";
import ErrorList from "@/components/ErrorList";
import WriteNoteList from "@/components/WriteNoteList";
import My from "@/components/My";
import Setting from "@/components/Setting";
import MessageList from "@/components/MessageList";
import MessageData from "@/components/MessageData";
import ExamDate from "@/components/ExamDate";
import About from "@/components/About";
import Memory from "@/components/Memory";
import Ebbinghaus from "@/components/Ebbinghaus";
import ChapterSubjectList from "@/components/ChapterSubjectList";

Vue.use(Router);

export default new Router({
  //mode: 'history',
  routes: [
    {
      path: "/",
      component: Index, //首页
      meta: {
        requireAuth: false, //是否需要登录
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/ClassList", //课程选择
      component: ClassList
    },
    {
      path: "/SearchSubject", //搜索题库
      component: SearchSubject,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/QuickReadSubject", //快速背题
      component: QuickReadSubject
    },
    {
      path: "/MyClassList", //我的课程
      component: MyClassList
    },
    {
      path: "/CourseOutlineList", //精华专区列表
      component: CourseOutlineList
    },
    {
      path: "/CourseOutlineData", //精华专区内容
      component: CourseOutlineData
    },
    {
      path: "/ChapterExercise", //专项练习
      component: ChapterExercise
    },
    {
      path: "/SubjuectData", //做题
      component: SubjuectData,
      meta: {
        isBack: false //是否允许返回
      }
    },
    {
      path: "/ClassBuy", //软件激活
      component: ClassBuy
    },
    {
      path: "/SimulationTest", //万人模考
      component: SimulationTest
    },
    {
      path: "/BuildPaper", //随机组卷
      component: BuildPaper
    },
    {
      path: "/ErrorInfo", //错题重做
      component: ErrorInfo
    },
    {
      path: "/ErrorList", //错题重做
      component: ErrorList
    },
    {
      path: "/WriteNoteList", //收藏笔记
      component: WriteNoteList
    },
    {
      path: "/My", //我的
      component: My
    },
    {
      path: "/Setting", //设置
      component: Setting
    },
    {
      path: "/MessageList", //消息列表
      component: MessageList
    },
    {
      path: "/MessageData", //消息内容
      component: MessageData
    },
    {
      path: "/ExamDate", //距离考试
      component: ExamDate
    },
    {
      path: "/About", //关于金考典
      component: About
    },{
      path: "/Memory", //科学记忆
      component: Memory
    },
    {
      path: "/Ebbinghaus", //艾宾浩斯
      component: Ebbinghaus
    },
    {
      path: "/ChapterSubjectList", //错题或笔记章节题目
      component: ChapterSubjectList,
      meta: {
        keepAlive: true // 需要被缓存
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js